<template >
  <div
    v-bind:class="[
      showContainer == true ? 'container-fluid' : 'container-fluid',
    ]"
    v-if="lesson"
  >
    <div class="row">
      <div class="col col-md-8 col-sm-12">
        <div class="card shadow-none mb-0" v-if="topic && item">
          <div class="card-header">
            <div class="row justify-content-between">
              <div class="col">
                <h5 class="m-0 font-weight-bold text-primary">
                  {{ topic.name }} / {{ item.name }}
                  <div
                    v-if="item.type != null && item.type != undefined"
                    class="ml-2 btn btn-sm badge badge-warning"
                    style="color: black"
                  >
                    {{ getType(item.type) }}
                  </div>
                </h5>
                <small>Товч нэр: {{ item.shortname }}</small>
              </div>
              <div class="col-auto">
                <i
                  class="fas fa-edit"
                  style="cursor: pointer"
                  title="Агуулгын мэдээллийг засаx"
                  @click="_editContent(item, topic)"
                ></i>
              </div>
              <!-- <button @click="openSaveContentFileModal(topic, item)" class="ml-2 btn btn-sm btn-outline-info">Файл оруулах</button>   -->
            </div>
          </div>
          <div class="card-body">
            <div v-if="item">
              <div v-if="item.description" role="alert">
                <p class="mb-1">{{ item.description }}</p>
              </div>

              <div class="row">
                <div class="col col-expand">
                  <p class="mb-1" v-if="item.duration != null">
                    <span class="font-weight-bold">Үргэлжлэх хугацаа: </span
                    >{{ item.duration }} минут
                  </p>
                  <p class="mb-1" v-if="item.startDay != null">
                    <span class="font-weight-bold">Эхлэх: </span>
                    {{ item.startDay | formatDate }}
                  </p>
                  <p class="mb-1 text-danger" v-if="item.endDay != null">
                    Дуусах:
                    <span class="font-weight-bold">{{
                      item.endDay | formatDate
                    }}</span>
                  </p>

                  <div v-if="item.type && item.type == 'assignment'">
                    <div class="row justify-content-between">
                      <div class="col">
                        <p class="font-weight-normal" v-if="item.totalScore">
                          <span class="font-weight-bold"
                            >Дүгнэх дээд оноо:</span
                          >
                          <span class="text-danger font-weight-bold">
                            {{ item.totalScore }}</span
                          >
                        </p>
                      </div>
                      <div>
                        <div
                          v-if="item.showScore == true"
                          style="cursor: pointer"
                          @click="
                            setPropContent(false, topic, item, 'showScore')
                          "
                        >
                          <span class="btn btn-sm btn-outline-default"
                            >Дүн харах боломжгүй болгох</span
                          >
                        </div>
                        <div
                          v-else
                          @click="
                            setPropContent(true, topic, item, 'showScore')
                          "
                          style="cursor: pointer"
                        >
                          <span class="btn btn-sm btn-danger"
                            >Дүн нээлттэй болгох</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-auto">
                  <div
                    v-if="item.type == 'video'"
                    class="btn btn-danger btn-sm"
                    style="cursor: pointer"
                    title="Таны видеонд гарч байгаа сэдвүүдийн талаар ойлгосон үгүйг xянаx."
                    @click="openSubContentModal"
                  >
                    Ойлголт хэмжих
                  </div>
                  <div>
                    <ul v-if="itemDetails != null && itemDetails.length > 0">
                      <li v-for="subdetail in itemDetails">
                        {{ subdetail.data().name }}({{
                          subdetail.data().numberOfUnderstand
                        }})
                        <i
                          class="fas fa-edit text-danger"
                          @click="_editSub(subdetail)"
                        ></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <hr />
              <div v-if="item.graded && item.graded == true && item.totalScore">
                <!-- <button class="btn btn-sm btn-primary" @click="$router.push({'name': 'ILessonContentScores', params: {schoolId: schoolId, lessonId: lessonId, topicId: topicId, contentId: item.id} })">Нийт дүн оруулах</button> -->

                <ul
                  v-if="
                    lesson &&
                    lesson.isGroup &&
                    lesson.isGroup == true &&
                    lesson.lessonGroups &&
                    lesson.lessonGroups.length > 0
                  "
                  class="mt-3"
                >
                  <h5 class="text-primary">Xичээлийн группууд</h5>
                  <hr />
                  <li
                    v-for="(group, gindex) in lesson.lessonGroups"
                    class="font-weight-bold"
                    v-bind:key="gindex"
                  >
                    <div class="d-flex justify-content-between mb-4">
                      <span class="text-secondary">{{ group.groupName }}</span>
                      <button
                        class="btn btn-sm btn-danger"
                        @click="
                          $router.push({
                            name: 'ILessonContentScores',
                            params: {
                              schoolId: schoolId,
                              lessonId: lessonId,
                              topicId: topic.id,
                              contentId: item.id,
                              groupId: group.group.id,
                            },
                          })
                        "
                      >
                        Дүн оруулах
                      </button>
                    </div>
                  </li>
                </ul>
                <ul
                  v-if="
                    lesson &&
                    lesson.isGroup != true &&
                    lesson.groups &&
                    lesson.groups.length > 0
                  "
                  class="mt-3 p-0"
                >
                  <h5 class="font-weight-bold">Хичээл заагдах бүлгүүд</h5>
                  <li
                    v-for="(group, index) in lesson.groups"
                    class="mt-3 ml-0 list-group-item"
                    v-bind:key="index"
                  >
                    <div class="row">
                      <div class="col">
                        <span class="text-primary font-weight-bold"
                          >{{ group.departmentName }}/{{
                            group.programName
                          }}</span
                        >
                      </div>
                      <div>
                        <button
                          class="btn btn-sm btn-outline-default"
                          @click="
                            $router.push({
                              name: 'ILessonContentScores',
                              params: {
                                schoolId: schoolId,
                                lessonId: lessonId,
                                topicId: topic.id,
                                contentId: item.id,
                                programId: group.program.id,
                              },
                            })
                          "
                        >
                          Дүгнэx
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div style="margin-bottom: 18px" v-if="item.videoUrl != null">
                <a v-bind:href="item.videoUrl" target="blank">
                  {{ item.videoUrl }}
                </a>
                <br />
                <iframe
                  width="100%"
                  height="600"
                  v-if="
                    item.videoUrl != null &&
                    item.videoUrl != '' &&
                    item.videoUrl.toLowerCase().indexOf('youtube') != -1
                  "
                  v-bind:src="getYoutubeIframe(item.videoUrl)"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
              <div v-if="item.iframeurl && item.iframeurl != ''">
                <div id="iframecontainer" v-html="item.iframeurl"></div>
              </div>

              <div v-if="item.fileUrls != null && item.fileUrls.length > 0">
                <hr />
                <h5 class="text-center">Файлууд</h5>
                <table class="table table-bordered table-sm">
                  <tr v-for="(file, index) in item.fileUrls">
                    <td>{{ file.name }}</td>
                    <td>{{ file.description }}</td>
                    <td>
                      <button
                        class="btn btn-outline-danger btn-sm mr-2"
                        @click="_deleteContentFile(topic, item, file, index)"
                      >
                        устгах
                      </button>
                      <a
                        class="btn btn-outline-primary btn-sm mr-2"
                        v-bind:href="file.link"
                        target="_blank"
                      >
                        <i class="fas fa-download"></i>
                        Татах
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <hr class="mb-5" />
      </div>
      <div class="col col-md-4 col-sm-12">
        <div class="doscroll2">
          <template v-if="topics != null">
            <div v-for="(topic, index) in topics" v-bind:key="topic.id">
              <h6 class="card-title mb-0 mt-2 font-weight-bold">
                <span class="text-primary">Сэдэв {{ index + 1 }}:</span
                >{{ topic.name }}
              </h6>
              <hr class="mt-0" />
              <div
                class="row mb-2"
                v-for="rowItem in topic.details"
                v-bind:key="rowItem.id"
                @click="setCurrentVideo(topic, rowItem)"
                :style="item.id==rowItem.id?'background:#ebebeb':''"
              >
                <div class="col-md-4">
                  <div v-if="rowItem.videoUrl">
                    <a style="cursor: pointer">
                      <img
                        style="width: 100%"
                        :src="getYoutubeImg(rowItem.videoUrl)"
                        alt=""
                      />
                    </a>
                  </div>
                  <div v-else class="my-2">
                    <a style="cursor: pointer">
                      <!-- <img style="width: 100%;" :src="'https://via.placeholder.com/300x200/09f/fff.png?text='+item.name" alt="">  -->

                      <div
                        v-if="item.type == 'lecture'"
                        style="
                          text-align: center;
                          color: white;
                          height: 100px !important;
                          background-color: blue;
                          line-height: 100px;
                        "
                        class="bg-primary"
                      >
                        {{ rowItem.name }}
                      </div>
                      <div
                        v-else-if="item.type == 'test'"
                        style="
                          text-align: center;
                          color: white;
                          height: 100px !important;
                          background-color: blue;
                          line-height: 100px;
                        "
                        class="bg-primary"
                      >
                        {{ rowItem.name }}
                      </div>
                      <div
                        v-else-if="item.type == 'assignment'"
                        style="
                          text-align: center;
                          color: white;
                          height: 100px !important;
                          background-color: blue;
                          line-height: 100px;
                        "
                        class="bg-danger"
                      >
                        {{ rowItem.name }}
                      </div>
                      <div
                        v-else
                        style="
                          text-align: center;
                          color: white;
                          height: 100px !important;
                          background-color: blue;
                          line-height: 100px;
                        "
                        class="bg-info"
                      >
                        {{ rowItem.name }}
                      </div>
                    </a>
                  </div>
                </div>
                <div class="col-md-8">
                  <div>
                    <span style="cursor: pointer; color: black">{{
                      rowItem.name
                    }}</span>
                  </div>
                  <div
                    v-if="rowItem.type == 'lecture'"
                    class="badge badge-warning"
                    style="color: black"
                  >
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>
                  <div
                    v-else-if="rowItem.type == 'video'"
                    class="badge badge-warning"
                    style="color: black"
                  >
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>
                  <div
                    v-else-if="rowItem.type == 'seminar'"
                    class="badge badge-warning"
                    style="color: black"
                  >
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>

                  <div
                    v-else-if="rowItem.type == 'coursework'"
                    class="badge badge-info"
                    style="color: black"
                  >
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>
                  <div
                    v-else-if="rowItem.type == 'assignment'"
                    class="badge badge-info"
                    style="color: black"
                  >
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>
                  <div
                    v-else-if="rowItem.type == 'coursework'"
                    class="badge badge-info"
                    style="color: black"
                  >
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>

                  <div
                    v-else-if="rowItem.type == 'test'"
                    class="badge badge-danger"
                    style="color: black"
                  >
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>
                  <div
                    v-else-if="rowItem.type == 'exam'"
                    class="badge badge-danger"
                    style="color: black"
                  >
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>

                  <div v-else class="badge badge-warning" style="color: black">
                    {{ getType(rowItem.type) }} /{{ rowItem.type }}/
                  </div>

                  <!-- <p class="views">xxx</p> -->
                </div>
              </div>
            </div>
          </template>

          <div v-else class="alert alert-warning text-center mb-4">
            <h5>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h5>
          </div>
        </div>
      </div>
    </div>

    <!-- ContentModal -->
    <div
      class="modal fade"
      id="contentModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="contentModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Агуулга нэмэх</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="content">
            <form class="user">
              <div class="form-group">
                <label class="d-flex justify-content-between">
                  <span>Агуулгын нэр:</span>
                  <small
                    class="text-primary"
                    @click="content.name = null"
                    style="cursor: pointer"
                    >арилгаx</small
                  >
                </label>

                <input
                  v-model.trim="content.name"
                  class="form-control"
                  placeholder="Агуулгын нэр"
                />
              </div>
              <div class="form-group">
                <label class="d-flex justify-content-between">
                  <span>Агуулгын товч нэр:</span>
                  <small
                    class="text-primary"
                    @click="content.shortname = null"
                    style="cursor: pointer"
                    >арилгаx</small
                  >
                </label>
                <input
                  v-model.trim="content.shortname"
                  class="form-control"
                  placeholder="Агуулгын товч нэр /VA, VariantB/"
                />
              </div>
              <div class="form-group">
                <label class="d-flex justify-content-between">
                  <span>Агуулгын дэлгэрэнгүй тайлбар: </span>
                  <small
                    class="text-primary"
                    @click="content.description = null"
                    style="cursor: pointer"
                    >арилгаx</small
                  >
                </label>
                <textarea
                  rows="4"
                  v-model.trim="content.description"
                  class="form-control"
                  placeholder="Агуулгын дэлгэрэнгүй"
                />
              </div>
              <div class="form-group">
                <label class="d-flex justify-content-between">
                  <span>Youtube видеоны линк:</span>
                  <small
                    class="text-primary"
                    @click="content.videoUrl = null"
                    style="cursor: pointer"
                    >арилгаx</small
                  >
                </label>
                <input
                  v-model.trim="content.videoUrl"
                  class="form-control"
                  placeholder="Видеоны линк"
                />
              </div>
              <div class="form-group">
                <label class="d-flex justify-content-between">
                  <span
                    ><span color="text-primary">IFrame</span> линк /Жишээлбэл:
                    GoogleDoc, Slide, Microsoft office, Slideshare .../</span
                  >
                  <small
                    class="text-primary"
                    @click="content.iframeurl = null"
                    style="cursor: pointer"
                    >арилгаx</small
                  >
                </label>

                <textarea
                  rows="2"
                  v-model.trim="content.iframeurl"
                  class="form-control"
                  placeholder=""
                />
              </div>
              <div class="form-group">
                <label for="exampleFormControlSelect1">Агуулгын төрөл: </label>
                <select class="form-control" v-model="selectedType">
                  <option
                    v-for="type in types"
                    v-bind:key="type.id"
                    v-bind:value="type.id"
                  >
                    {{ type.title }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Эхлэх: </label>
                <input
                  v-model="content.startDayStr"
                  class="form-control form_datetime"
                  type="date"
                  placeholder="Агуулга нээгдэх хугацаа"
                />
              </div>
              <div class="form-group">
                <label>Дуусах: </label>
                <input
                  v-model="content.endDayStr"
                  class="form-control form_datetime"
                  type="date"
                  placeholder="Агуулга дуусах хугацаа"
                />
              </div>
              <div class="form-group">
                <label>Агуулгын үргэлжлэх хугацаа/мин/: </label>
                <input
                  v-model.number="content.duration"
                  class="form-control"
                  type="number"
                  placeholder="Агуулгын үргэлжлэх хугацаа"
                />
              </div>
              <div
                class="row"
                v-if="selectedType && selectedType == 'assignment'"
              >
                <div class="col">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      v-model="content.graded"
                      class="form-check-input"
                      id="exampleCheck1"
                    />
                    <label class="form-check-label" for="exampleCheck1"
                      >Оноотой эсэх</label
                    >
                  </div>
                </div>
                <div
                  class="col"
                  v-if="content && content.graded && content.graded == true"
                >
                  <div class="form-group">
                    <label>Дүгнэх дээд онооx: </label>
                    <input
                      v-model.number="content.totalScore"
                      class="form-control"
                      type="number"
                      placeholder="Дээд оноо"
                    />
                  </div>
                </div>
              </div>
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Хаах
            </button>
            <button
              @click="saveContent(selectedTopic)"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >
              Хадгалах
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="submodal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="submodalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ойлголт xэмжиx</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="sub">
            <div class="alert alert-warning" role="alert">
              Видео xичээл дээр ярьсан сэдвийнxээ xүрээнд нарийвчлан дэд
              сэдвүүдийг оруулж, суралцагчдынxаа ойлголтыг шалгаx боломжтой.
            </div>
            <form class="user">
              <div class="form-group">
                <label>Дэд сэдвийн нэр: </label>
                <input
                  v-model.trim="sub.name"
                  class="form-control"
                  placeholder="Заасан агуулгын нэр"
                />
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Хаах
            </button>
            <button
              @click="saveSubContent(sub)"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >
              Хадгалах
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- FileModal -->
    <div
      class="modal fade"
      id="fileModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="fileModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="item">
          <div class="modal-header">
            <div class="row">
              <div class="col">
                <h5 class="modal-title">Файл оруулах</h5>
              </div>
              <div class="col">
                {{ item.name }}
              </div>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Гарчиг: </label>
                <input
                  v-model.trim="filecontent.name"
                  class="form-control"
                  placeholder="Гарчиг"
                />
              </div>
              <div class="form-group">
                <label>Дэлгэрэнгүй тайлбар: </label>
                <textarea
                  rows="2"
                  v-model.trim="filecontent.description"
                  class="form-control"
                  placeholder="дэлгэрэнгүй"
                />
              </div>
              <div class="form-group">
                <label>Файл татах холбоос линк: </label>
                <input
                  v-model.trim="filecontent.link"
                  class="form-control"
                  placeholder="Линк /файл татах холбоос/"
                />
              </div>

              <hr />
              <p class="text-center text-danger">
                Жишээлбэл та Google Drive файлын 'share link' хуулж тавьж болно.
              </p>
              <p
                class="text-center text-danger py-2"
                style="border: 1px dashed #1cc88a; border-radius: 15px"
              >
                Хэрэв та Google Drive файл оруулах гэж байгаа бол
                <img src="/assets/img/file_ins.png" /> ➔
                <img src="/assets/img/file_ins_1.png" /> буюу public тохиргоотой
                линкийг хуулж тавиарай.!!!
              </p>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Хаах
            </button>
            <button
              @click="saveContentFile"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >
              Хадгалах
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import LessonHeader from "../lesson/ILessonHeader";

export default {
  name: "IContentDetail",
  components: {
    LessonHeader,
  },
  data() {
    return {
      lesson: null,
      topic: null,
      item: null,
      types: [],
      selectedType: null,
      content: {},
      itemDetails: [],
      selectedTopic: null,

      display: 0,
      topicBucket: "lessonTopicFiles/",
      sub: {
        name: null,
      },
      filecontent: {
        name: null,
        link: null,
        description: null,
      },
      semesters: [],
      school: null,
      topics: [],
    };
  },
  methods: {
    setCurrentVideo(topic, item) {
      this.$nextTick(() => {
        this.topic = topic;
        this.item = item;
        this.itemDetails = [];
        fb.db
          .doc(
            "schools/" +
              this.schoolId +
              "/lessons/" +
              this.lessonId +
              "/topics/" +
              topic.id +
              "/details/" +
              item.id
          )
          .collection("subdetails")
          .orderBy("createdAt", "desc")
          .onSnapshot((docs) => {
            if (docs != null && !docs.empty) {
              this.itemDetails = docs.docs;
            }
          });
      });
    },

    _setupp() {
      fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get()
        .then((schoolDoc) => {
          if (schoolDoc.exists) {
            let school = schoolDoc.data();
            school.id = schoolDoc.id;
            this.school = school;
            fb.db
              .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
              .collection("topics")
              .orderBy("createdAt", "desc")
              .get()
              .then((querySnapshot) => {
                this.topics = [];
                querySnapshot.forEach((doc) => {
                  let topic = doc.data();
                  topic.id = doc.id;
                  topic.details = [];
                  doc.ref
                    .collection("details")
                    .orderBy("createdAt")
                    .onSnapshot((contentSnapshot) => {
                      topic.details = [];
                      contentSnapshot.forEach((contentDoc) => {
                        let content = contentDoc.data();
                        content.id = contentDoc.id;
                        content.uploading = false;
                        content.uploadPercent = 0;
                        if (content && content.iframeurl) {
                          if (
                            content.iframeurl.includes(
                              "docs.google.com/document"
                            )
                          ) {
                            content.iframeurl = content.iframeurl.replace(
                              "<iframe ",
                              "<iframe style='height:1024px'"
                            );
                          }
                        }
                        topic.details.push(content);
                      });
                    });
                  this.topics.push(topic);
                });
              });
          }
        });
      fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .get()
        .then((doc) => {
          let lesson = doc.data();
          lesson.id = doc.id;
          this.lesson = lesson;
          doc.ref
            .collection("topics")
            .doc(this.topicId)
            .get()
            .then((tdoc) => {
              if (tdoc.exists) {
                let topic = tdoc.data();
                topic.id = tdoc.id;
                this.topic = topic;

                tdoc.ref
                  .collection("details")
                  .doc(this.contentId)
                  .onSnapshot((cdoc) => {
                    if (cdoc.exists) {
                      let item = cdoc.data();
                      item.id = cdoc.id;
                      item.uploading = false;
                      item.uploadPercent = 0;
                      if (!item.startDayStr) item.startDayStr = null;
                      if (!item.endDayStr) item.endDayStr = null;
                      if (!item.startDay) item.startDay = null;
                      if (!item.endDay) item.endDay = null;
                      if (item && item.iframeurl) {
                        if (
                          item.iframeurl.includes("docs.google.com/document")
                        ) {
                          item.iframeurl = item.iframeurl.replace(
                            "<iframe ",
                            "<iframe style='height:1024px'"
                          );
                        }
                      }

                      this.item = item;
                      cdoc.ref
                        .collection("subdetails")
                        .orderBy("createdAt", "desc")
                        .onSnapshot((docs) => {
                          if (docs != null && !docs.empty) {
                            this.itemDetails = docs.docs;
                          }
                        });
                    }
                  });
              }
            });
        });

      fb.db
        .collection("ContentTypes")
        .get()
        .then((querySnapshot) => {
          this.types = [];
          querySnapshot.forEach((doc) => {
            let object = doc.data();
            object.id = doc.id;
            object.content = [];
            this.types.push(object);
          });
        });
    },
    saveContent(topic) {
      if (
        this.content != null &&
        this.content.name != null &&
        this.content.name != "" &&
        this.selectedType != null
      ) {
        if (this.content.videoUrl != null && this.content.videoUrl != "") {
          if (this.content.videoUrl.toLowerCase().indexOf("youtube") == -1) {
            alert("Та заавал youtube бичлэг оруулна уу");
            return;
          }
        }
        this.content.typeRef = fb.db
          .collection("ContentTypes")
          .doc(this.selectedType);
        this.content.type = this.selectedType;

        if (
          this.lesson != null &&
          this.topic != null &&
          this.topic.id != null &&
          this.content
        ) {

          if (
            this.content.startDayStr != null &&
            this.content.startDayStr != ""
          ) {
            this.content.startDay = new Date(this.content.startDayStr);
          }

          if (this.content.endDayStr != null && this.content.endDayStr != "") {
            this.content.endDay = new Date(this.content.endDayStr);
            this.content.endDay.setHours(23, 59, 0);
          }

          if (this.selectedType != null && this.selectedType == "exam") {
            this.content.roundCount = 1;
          } else if (this.selectedType != null && this.selectedType == "test") {
            this.content.roundCount = 10;
          }

          if (
            this.content.id != undefined &&
            this.content.id != null &&
            this.content.id != "" &&
            this.content.id != "new"
          ) {
            this.content.modifiedAt = new Date();
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(this.topic.id)
              .collection("details")
              .doc(this.content.id)
              .update(this.content);
          } else {
            this.content.createdAt = new Date();
            this.content.code = new Date().getTime().toString();
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(this.topic.id)
              .collection("details")
              .doc()
              .set(this.content);
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(this.topic.id)
              .update({
                numberOfContent: fb.firestore.FieldValue.increment(1),
              });

            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .update({
                numberOfContent: fb.firestore.FieldValue.increment(1),
              });

            if (this.content.videoUrl != null && this.content.videoUrl != "") {
              fb.db
                .collection("schools/" + this.schoolId + "/lessons")
                .doc(this.lessonId)
                .update({
                  numberOfVideos: fb.firestore.FieldValue.increment(1),
                });
            }
          }

          this.selectedType = null;
          this.selectedTopic = null;
          this.content = {
            name: null,
            description: null,
            videoUrl: null,
            published: false,
            startDay: null,
            endDay: null,
            code: null,
            duration: null,
            shortname: null,
            iframeurl: null,
          };
        }
        $("#contentModal").modal("hide");
      } else {
        alert("Та талбаруудыг гүйцэд бөглөнө үү");
      }
    },
    saveSubContent(sub) {
      if (sub != null && sub.name != null && sub.name != "") {
        if (
          this.lesson != null &&
          this.topic != null &&
          this.topic.id != null &&
          this.item != null &&
          this.item != undefined
        ) {
          if (
            sub.id != undefined &&
            sub.id != null &&
            sub.id != "" &&
            sub.id != "new"
          ) {
            sub.modifiedAt = new Date();
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(this.topic.id)
              .collection("details")
              .doc(this.item.id)
              .collection("subdetails")
              .doc(sub.id)
              .update(sub);
          } else {
            sub.createdAt = new Date();
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(this.topic.id)
              .collection("details")
              .doc(this.item.id)
              .collection("subdetails")
              .doc()
              .set(sub);
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(this.topic.id)
              .collection("details")
              .doc(this.item.id)
              .update({
                numberOfSubdetails: fb.firestore.FieldValue.increment(1),
              });
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .collection("topics")
              .doc(this.topic.id)
              .update({
                numberOfSubdetails: fb.firestore.FieldValue.increment(1),
              });
            fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .doc(this.lessonId)
              .update({
                numberOfSubdetails: fb.firestore.FieldValue.increment(1),
              });
          }

          this.sub = {
            name: null,
          };
        }
        $("#submodal").modal("hide");
      } else {
        alert("Та талбаруудыг гүйцэд бөглөнө үү");
      }
    },
    openSubContentModal() {
      this.sub = { name: null };
      $("#submodal").modal("show");
    },
    _editSub(subdetail) {
      this.sub = {
        id: subdetail.id,
        name: subdetail.data().name,
      };
      $("#submodal").modal("show");
    },
    openSaveContentModal(topic) {
      this.selectedTopic = topic;
      $("#contentModal").modal("show");
    },

    goStat(type, topic) {
      this.$router.push({
        name: "TopicStat",
        params: { lessonId: this.lessonId, type: type.id, topicId: topic.id },
      });
    },

    _editContent(content, topic) {
      this.content = Object.assign({}, content);
      this.selectedType = content.type;
      $("#contentModal").modal("toggle");
    },

    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },

    setPublished(value, lesson) {
      this.setProperty(
        "published",
        fb.db.doc("schools/" + this.schoolId + "/lessons/" + lesson.id),
        value
      );
      if (value == true) {
        if (lesson.school != null && lesson.school != undefined)
          lesson.school.update({
            publishedLesson: fb.firestore.FieldValue.increment(1),
          });
        if (lesson.department != null && lesson.department != undefined)
          lesson.department.update({
            publishedLesson: fb.firestore.FieldValue.increment(1),
          });
        if (lesson.program != null && lesson.program != undefined)
          lesson.program.update({
            publishedLesson: fb.firestore.FieldValue.increment(1),
          });

        var publish = firebase.functions().httpsCallable("publishLesson");
        publish({ lessonId: lesson.id });
      } else {
        if (lesson.school != null && lesson.school != undefined)
          lesson.school.update({
            publishedLesson: fb.firestore.FieldValue.increment(-1),
          });
        if (lesson.department != null && lesson.department != undefined)
          lesson.department.update({
            publishedLesson: fb.firestore.FieldValue.increment(-1),
          });
        if (lesson.program != null && lesson.program != undefined)
          lesson.program.update({
            publishedLesson: fb.firestore.FieldValue.increment(-1),
          });
        var unpublish = firebase.functions().httpsCallable("unPublishLesson");
        unpublish({ lessonId: lesson.id });
      }
    },
    setPropContent(value, topic, item, propertyName) {
      if (
        this.lesson != null &&
        topic != null &&
        item != null &&
        propertyName != null
      )
        this.setProperty(
          propertyName,
          fb.db.doc(
            "schools/" +
              this.schoolId +
              "/lessons/" +
              this.lesson.id +
              "/topics/" +
              topic.id +
              "/details/" +
              item.id
          ),
          value
        );

      item[propertyName] = value;
    },
    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },
    uploadFile(topic, content) {
      var _this = this;

      var files = this.$refs["file_" + content.id].files;
      if (files != null && files.length > 0) {
        var file = files[0];
        if (
          file.name.endsWith("mp4") ||
          file.name.endsWith("MP4") ||
          file.name.endsWith("MPEG") ||
          file.name.endsWith("mov") ||
          file.name.endsWith("MOV") ||
          file.name.endsWith("webm") ||
          file.name.endsWith("WEBM")
        ) {
          alert("Та video файл оруулах боломжгүй");
          return;
        }
        var now = new Date();
        var fileName = this.topicBucket + "_" + now.getTime() + "_" + file.name;
        var uploadTask = fb.storageRef.child(fileName).put(file);
        content.uploading = true;
        content.uploadPercent = 0;
        uploadTask.on(
          fb.storage.TaskEvent.STATE_CHANGED,
          function (snapshot) {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            content.uploadPercent = progress;
          },
          function (error) {
            switch (error.code) {
              case "storage/unauthorized":
                break;

              case "storage/canceled":
                break;
              case "storage/unknown":
                break;
            }
          },
          function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                let fileObject = {
                  fileName: fileName,
                  fileUrl: downloadURL,
                  realName: file.name,
                  uploadedAt: now,
                };
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(_this.lessonId)
                  .collection("topics")
                  .doc(topic.id)
                  .collection("details")
                  .doc(content.id)
                  .update({
                    files: fb.firestore.FieldValue.arrayUnion(fileObject),
                  });
                content.uploading = false;
                content.uploadPercent = 0;
              });
          }
        );
      }
    },
    _deleteTopicFile(topic, content, file, index) {
      var result = confirm("Та " + file.fileName + " файлыг устгах уу?");
      if (result) {
        var fileName = file.fileName;
        var fileRef = fb.storageRef.child(fileName);
        fileRef.delete();
        content.files.splice(index, 1);
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("topics/" + topic.id + "/details")
          .doc(content.id)
          .update({
            files: content.files,
          });
      }
    },
    validFile(file) {
      if (
        file.fileName.endsWith("mp4") ||
        file.fileName.endsWith("MP4") ||
        file.fileName.endsWith("MPEG") ||
        file.fileName.endsWith("mov") ||
        file.fileName.endsWith("MOV") ||
        file.fileName.endsWith("webm") ||
        file.fileName.endsWith("WEBM")
      ) {
        return false;
      }
      return true;
    },
    getYoutubeId(url) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11 ? match[2] : null;
    },
    getYoutubeImg(url) {
      if (url) {
        var id = this.getYoutubeId(url);
        if (id) {
          return "https://img.youtube.com/vi/" + id + "/1.jpg";
        }
      }
      return null;
    },
    getYoutubeIframe(url) {
      if (
        url != null &&
        url != "" &&
        url.toLowerCase().indexOf("youtube") != -1
      ) {
        var id = this.getYoutubeId(url);
        return "https://www.youtube.com/embed/" + id;
      }
      return null;
    },
    getType(type) {
      if (type == "test") return "Тест давтлага";
      else if (type == "video") return "Хичээл";
      else if (type == "lecture") return "Хичээл";
      else if (type == "seminar") return "Семинар";
      else if (type == "exam") return "Шалгалт";
      else if (type == "homework") return "Гэрийн даалгавар";
      else if (type == "coursework") return "Бие даалт";
      else if (type == "assignment") return "Даалгавар";
    },
    openSaveContentFileModal(topic, content) {
      this.filecontent = {
        name: null,
        link: null,
        description: null,
      };
      $("#fileModal").modal("show");
    },
    async saveContentFile() {
      if (
        this.topic &&
        this.content &&
        this.filecontent &&
        this.filecontent.link
      ) {
        await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("topics")
          .doc(this.topicId)
          .collection("details")
          .doc(this.contentId)
          .update({
            fileUrls: fb.firestore.FieldValue.arrayUnion(this.filecontent),
          });
        $("#fileModal").modal("hide");
      } else {
        alert("Та файлын мэдээллээ бүрэн оруулна уу.");
      }

      this.filecontent = {
        name: null,
        link: null,
        description: null,
      };
    },
    _deleteContentFile(topic, content, file, index) {
      var result = confirm("Та " + file.link + " файлыг устгах уу?");
      if (result) {
        content.fileUrls.splice(index, 1);
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("topics")
          .doc(topic.id + "/details/" + content.id)
          .update({
            fileUrls: content.fileUrls,
          });
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    topicId: {
      required: true,
    },
    contentId: {
      required: true,
    },
    showContainer: {
      required: false,
    },
  },
  created() {
    var _this = this;
    // $(document).ready(function() {
    //   $(function() {
    //     ($(".form_datetime"))
    //     // $(".form_datetime").datepicker({format: 'yyyy-mm-dd hh:ii'});
    //   });
    // });

    if (this.lessonId != null && this.lessonId != "") this._setupp();
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM-DD-YYYY HH:mm");
    },
  },
};
</script>

<style>
#iframecontainer iframe {
  width: 100% !important;
}
</style>